import {
  EnkelVirksomhetInfo,
  ForetakMedLenker,
} from "../../infrastructure/api/api";
import styles from "./FullmaktSkjema.module.less";
import Translated from "../../infrastructure/translation/Translated";
import { Heading } from "@digipost/dds-heading-react";
import { VirksomhetsKort } from "../../VirksomhetsKort/ViksomhetsKort";
import { useState } from "react";
import {
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
} from "@digipost/dds-buttons-react";
import { Checkbox } from "@digipost/dds-checkbox-react";
import { findUriIfExists } from "../../infrastructure/entrypoint/link";
import { InputWrapperWithErrorMessage } from "../../InputWrapperWithErrorMessage/InputWrapperWithErrorMessage";
import { ManuellKontaktinfo } from "../../Registreringsflyt/useRegistrerVirksomhet";
import { LoadingPage } from "../../LoadingPage/LoadingPage";

interface FullmaktSkjemaProps {
  integrasjonsPartner: EnkelVirksomhetInfo;
  registrerendeBedrift: ForetakMedLenker | ManuellKontaktinfo;
  goBack: () => void;
  accept: () => void;
}

function FullmaktSkjema({
  integrasjonsPartner,
  registrerendeBedrift,
  accept,
  goBack,
}: FullmaktSkjemaProps) {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showError, setShowError] = useState(false);

  const next = () => {
    if (!acceptedTerms) {
      setShowError(true);
    } else {
      accept();
    }
  };

  if (!registrerendeBedrift) {
    return <LoadingPage />;
  }

  let virksomhet;
  if ("orgName" in registrerendeBedrift) {
    virksomhet = registrerendeBedrift.orgName;
  } else {
    virksomhet = registrerendeBedrift.foretak?.navn;
  }

  return (
    <section>
      <Heading level={1} size={"large"}>
        <Translated textKey={"partneronboarding.fullmakt.header"} />
      </Heading>
      <p>
        <Translated
          textKey={"partneronboarding.fullmakt.infotext"}
          params={{
            partnerName: integrasjonsPartner.orgName,
            virksomhet,
          }}
        />
      </p>
      <Heading
        level={2}
        size={"small"}
        fontWeight={"bold"}
        className={styles.systemleverandorHeading}
      >
        <Translated textKey={"partneronboarding.system_provider"} />
      </Heading>
      <VirksomhetsKort
        navn={integrasjonsPartner.orgName}
        orgNr={integrasjonsPartner.orgNumber}
        logoUri={findUriIfExists(
          "ORGANISATION_LOGO",
          integrasjonsPartner._links,
          true,
        )}
        headingLevel={3}
        key={integrasjonsPartner.orgNumber}
      />
      <InputWrapperWithErrorMessage
        showError={showError}
        errorTextKey={"partneronboarding.fullmakt.checkbox_warning"}
        InputComponent={
          <Checkbox
            className={styles.fullmaktCheckbox}
            name={"acceptTerms"}
            value={"acceptTerms"}
            checked={acceptedTerms}
            onChange={(e) => {
              setAcceptedTerms(e.target.checked);
              setShowError(false);
            }}
          >
            <Translated
              textKey={"partneronboarding.fullmakt.checkbox"}
              params={{
                partnerName: integrasjonsPartner.orgName,
                virksomhet,
              }}
            />
          </Checkbox>
        }
      />

      <ButtonGroup className={styles.nesteOgTilbakeKnapper}>
        <SecondaryButton type="button" onClick={goBack}>
          <Translated textKey={"generic.back"} />
        </SecondaryButton>
        <PrimaryButton onClick={next}>
          <Translated textKey={"generic.next"} />
        </PrimaryButton>
      </ButtonGroup>
    </section>
  );
}

export default FullmaktSkjema;
